<template>
  <div class="navigate">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="nav-wrap">
          <div class="nav-main">
            <div class="brand" @click="goHome" aria-label="Go to homepage">
              <img :src="logo" alt="AiLife logo" />
            </div>

            <el-menu :default-active="activeIndex" mode="horizontal" class="navigate_row" router @select="handleSelect">
              <el-submenu index="/test-menu" popper-class="nav-popper">
                <template slot="title">
                  <span class="submenu-title">Test Menu</span>
                </template>

                <el-menu-item index="/test/WholeGenomeSequencingProbandOnly">
                  Whole Genome Sequencing
                </el-menu-item>
                <el-menu-item index="/test/WholeExomeSequencingProbandOnly">
                  Whole Exome Sequencing
                </el-menu-item>

                <el-submenu index="/test/clinical" popper-class="nav-popper clinical-mega-popper">
                  <template slot="title">Clinical Specialties</template>
                  <el-menu-item index="/test/category/audiology">Audiology</el-menu-item>
                  <el-menu-item index="/test/category/cardiology">Cardiology</el-menu-item>
                  <el-menu-item index="/test/category/connective-tissue-and-skin">Connective Tissue and Skin</el-menu-item>
                  <el-menu-item index="/test/category/endocrinology">Endocrinology</el-menu-item>
                  <el-menu-item index="/test/category/gastroenterology">Gastroenterology</el-menu-item>
                  <el-menu-item index="/test/category/genome-wide-cnv-analysis">Genome-Wide CNV Analysis</el-menu-item>
                  <el-menu-item index="/test/category/healthy-screening">Healthy Screening</el-menu-item>
                  <el-menu-item index="/test/category/hematology">Hematology</el-menu-item>
                  <el-menu-item index="/test/category/immunology">Immunology</el-menu-item>
                  <el-menu-item index="/test/category/intellectual-disability">Intellectual Disability</el-menu-item>
                  <el-menu-item index="/test/category/metabolic">Metabolic</el-menu-item>
                  <el-menu-item index="/test/category/mitochondrial-genome-sequencing">Mitochondrial Genome Sequencing</el-menu-item>
                  <el-menu-item index="/test/category/nephrology">Nephrology</el-menu-item>
                  <el-menu-item index="/test/category/neurology">Neurology</el-menu-item>
                  <el-menu-item index="/test/category/oncology">Oncology</el-menu-item>
                  <el-menu-item index="/test/category/ophthalmology">Ophthalmology</el-menu-item>
                  <el-menu-item index="/test/category/overgrowth-disorders">Overgrowth Disorders</el-menu-item>
                  <el-menu-item index="/test/category/pharmacogenomics">Pharmacogenomics</el-menu-item>
                  <el-menu-item index="/test/category/pulmonology">Pulmonology</el-menu-item>
                  <el-menu-item index="/test/category/repeat-expansion-disorders">Repeat Expansion Disorders</el-menu-item>
                  <el-menu-item index="/test/category/skeletal-and-dental">Skeletal and Dental</el-menu-item>
                </el-submenu>
              </el-submenu>

              <el-submenu index="/order" popper-class="nav-popper">
                <template slot="title">
                  <span class="submenu-title">How To Order</span>
                </template>
                <el-menu-item index="/order/testing">How To Order Testing</el-menu-item>
                <el-menu-item index="/order/specimen">Specimen Requirements</el-menu-item>
                <el-menu-item index="/order/billing">Billing &amp; Insurance</el-menu-item>
                <el-menu-item index="/order/policies">Lab Policies</el-menu-item>
                <el-menu-item index="/order/forms">Forms</el-menu-item>
              </el-submenu>

              <el-submenu index="/resources" popper-class="nav-popper">
                <template slot="title">
                  <span class="submenu-title">Resources</span>
                </template>
                <el-menu-item index="/clinical-case-examples">Clinical Case Examples</el-menu-item>
                <el-menu-item index="/products/RequestGeneticistConsultation">Request Geneticist Consultation</el-menu-item>
                <el-menu-item index="/products/VariantInterpretationService">Variant Interpretation Service</el-menu-item>
                <el-menu-item index="/products/Brochures">Product Brochures</el-menu-item>
                <el-menu-item index="/products/UnderstandingResults">Understanding Results</el-menu-item>
              </el-submenu>

              <el-submenu index="/Services" popper-class="nav-popper">
                <template slot="title">
                  <span class="submenu-title">Industry and Research Services</span>
                </template>
                <el-menu-item index="/Services/BioPharmaPartnerships">
                  BioPharma Partnerships
                </el-menu-item>
                <el-menu-item index="/Services/AilisNGS">
                  AilisNGS<sup class="registered-symbol">&#174;</sup>
                </el-menu-item>
              </el-submenu>
            </el-menu>

            <div class="nav-actions">
              <search class="nav-search" />
              <div class="portal-outline" @click="goPortal">
                Portal Login
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import picture from "@/utils/img";
import search from "@/views/search";

export default {
  components: { search },
  name: "navigate",
  data() {
    return {
      logo: picture.logo(),
      activeIndex: this.getActiveIndex(this.$route.path),
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.activeIndex = this.getActiveIndex(val.path);
      },
      immediate: true,
    },
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/home" });
    },
    goPortal() {
      window.open("https://report.ailifeus.com", "_blank");
    },
    handleSelect(key) { },
    getActiveIndex(path) {
      return path;
    },
  },
};
</script>

<style lang="scss">
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  text-align: center !important;
  color: $color_black !important;
}

.registered-symbol {
  font-size: 0.6em;
  top: -0.6em;
  position: relative;
  margin-left: 1px;
}

.nav-popper .el-menu--popup {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #dcdfe6;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.clinical-mega-popper {
  .el-menu--popup {
    width: 780px !important;
    display: flex !important;
    flex-wrap: wrap !important;
    flex-direction: row !important;
    padding: 12px !important;
    align-content: flex-start;

    & > div:not(.el-menu-item):not(.el-submenu) {
      display: none !important;
    }

    .el-menu-item {
      flex: 0 0 calc(33.333% - 10px) !important;
      margin: 2px 5px !important;
      height: 40px !important;
      line-height: 40px !important;
      text-align: left !important;
      padding: 0 12px !important;
      box-sizing: border-box;
      display: flex !important;
      align-items: center;
    }

    .el-menu-item:last-child:nth-child(3n + 1) {
      flex: 0 0 calc(100% - 10px) !important;
    }
  }
}

.navigate {
  background: #ffffff;
  height: auto;

  .el-row {
    padding: 5px 0;
    box-sizing: border-box;
  }

  .nav-wrap {
    width: 100%;
    height: auto;
    min-height: 72px;
  }

  .nav-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    flex-wrap: nowrap;
  }

  .brand {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    user-select: none;
    padding: 6px 10px;
    border-radius: 10px;
    flex: 0 0 auto;

    img {
      width: 150px;
      object-fit: contain;
      display: block;
    }
  }

  .el-menu.el-menu--horizontal {
    border: none;
    flex: 1 1 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
    height: auto;
    overflow: visible;
    min-width: 0;
  }

  .el-menu-item {
    height: 52px !important;
    line-height: 52px !important;
    color: $color_black !important;
    font-weight: 500;
    font-size: 14px;
    padding: 0 7px !important;
  }

  .submenu-title {
    display: inline-flex;
    align-items: center;
    height: 52px;
    line-height: 52px;
    padding: 0 4px;
    color: $color_black;
    font-weight: 500;
    font-size: 14px;
    white-space: nowrap;
  }

  .el-submenu__title {
    height: 52px !important;
    line-height: 52px !important;
    padding: 0 5px !important;
  }

  .nav-popper {
    .el-menu-item {
      height: 44px !important;
      line-height: 44px !important;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .nav-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
  }

  .nav-search {
    flex: 0 0 180px;
    max-width: 180px;
    min-width: 160px;
  }

  .portal-outline {
    padding: 7px 12px;
    font-size: 13px;
    font-weight: 700;
    border-radius: 999px;
    cursor: pointer;
    white-space: nowrap;
    background: #1a73e8;
    color: #fff;
    border: none;
  }
}

/* 宽度不够时：Search + Login 整体放到第二行 */
@media (max-width: 1250px) {
  .navigate {
    .nav-main {
      flex-wrap: wrap;
      align-items: center;
    }

    .brand {
      order: 1;
    }

    .el-menu.el-menu--horizontal {
      order: 2;
      flex: 1 1 auto;
      justify-content: flex-end;
    }

    .nav-actions {
      order: 3;
      width: 100%;
      justify-content: flex-end;
      padding: 0 10px 8px 10px;
      box-sizing: border-box;
    }

    .el-menu-item,
    .el-submenu__title {
      height: 48px !important;
      line-height: 48px !important;
    }

    .submenu-title {
      height: 48px;
      line-height: 48px;
    }
  }
}

/* 更窄屏幕：菜单和搜索区域左对齐 */
@media (max-width: 900px) {
  .navigate {
    .nav-main {
      justify-content: flex-start;
    }

    .brand {
      width: auto;
    }

    .el-menu.el-menu--horizontal {
      width: 100%;
      justify-content: flex-start;
      flex-wrap: wrap;
    }

    .nav-actions {
      justify-content: flex-start;
    }
  }
}

/* 手机端：Search 和 Login 分成上下两行 */
@media (max-width: 600px) {
  .navigate {
    .brand img {
      width: 135px;
    }

    .nav-actions {
      flex-direction: column;
      align-items: flex-start;
    }

    .nav-search {
      width: 100%;
      max-width: 100%;
      flex: 0 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/header/header.vue